import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../utils';

export type CodeProps = ComponentPropsWithoutRef<'code'>;

export const Code = ({ className, ...props }: CodeProps) => (
  <code
    className={cn(
      'whitespace-nowrap rounded-md bg-zinc-900 px-1.5 py-0.5 font-mono text-[0.875em] text-white dark:bg-zinc-100 dark:text-zinc-900',
      className
    )}
    {...props}
  />
);
